var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "form-info-container" }, [
    _c("div", { staticClass: "form-info" }, [
      _c("span", { staticClass: "message" }, [
        _vm._v(_vm._s(_setup.props.message)),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }